import { gql, type MutationHookOptions, useMutation } from "@apollo/client";

interface DataType {
  leaveAllEscapes: {
    removed: boolean;
  };
}

interface VariablesType {
  gameId: string;
}

const MUTATION = gql`
  mutation LeaveAllEscapes($gameId: ID!) {
    leaveAllEscapes(gameId: $gameId) {
      removed
    }
  }
`;

export default function useLeaveAllEscapesMutation(
  props?: MutationHookOptions<DataType, VariablesType>
) {
  return useMutation<DataType, VariablesType>(MUTATION, props);
}
